<template>
  <div class="about-page">
    <!-- 头部导航 - 使用公共组件 -->
    <Navbar />

    <!-- Hero Section -->
    <section class="hero-section" :style="{ backgroundImage: `url(${heroBackground})` }">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="hero-content">
          <h1 class="hero-title">关于我们</h1>
          <p class="hero-subtitle">专业检测，守护安全</p>
          <p class="hero-description">
            陕西慧安和信检测有限公司成立于2017年08月，是一家专注于工业安全领域的第三方检测服务机构，致力于为各行业提供专业、可靠的安全设备检测与评估服务
          </p>
        </div>
      </div>
    </section>

    <!-- 公司简介 -->
    <section id="company" class="company-intro-section">
      <div class="container">
        <div class="intro-wrapper">
          <div class="intro-content">
            <h2 class="section-title">公司简介</h2>
            <div class="intro-text">
              <p>陕西慧安和信检测有限公司成立于2017年08月，坐落于西安经济技术开发区，是经市场监督管理局依法批准的第三方检验检测机构，具有独立法人资格。</p>
              <p>公司现开展的业务有空气呼吸器、气体检测报警仪及呼吸器用复合气瓶的检测。</p>
              <p>公司以"科学、公正、专业、高效"的质量方针，凭借精密的仪器设备及精湛的技术团队，秉承"质量第一、用户至上"的服务理念，不断为客户提供优质、高效、满意的技术服务，多年来公司凭借专业的技术水平、一流的技术服务零差错率等优势获得了客户的一致好评。</p>
            </div>
            <div class="company-stats">
              <div class="stat-item">
                <div class="stat-number">500+</div>
                <div class="stat-label">服务企业</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">10000+</div>
                <div class="stat-label">检测设备</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">99.8%</div>
                <div class="stat-label">客户满意度</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">8年</div>
                <div class="stat-label">专业经验</div>
              </div>
            </div>
          </div>
          <div class="intro-image">
            <img src="@/assets/hj2.png" alt="慧安检测办公环境" />
          </div>
        </div>
      </div>
    </section>

    <!-- 企业文化 -->
    <section id="culture" class="culture-section">
      <div class="container">
        <h2 class="section-title">企业文化</h2>
        <div class="culture-grid">
          <div class="culture-card">
            <div class="culture-icon">
              <i class="el-icon-aim"></i>
            </div>
            <h3 class="culture-title">企业使命</h3>
            <p class="culture-desc">以专业的检测技术和优质的服务，为安全防护保驾护航，保障人民生命财产安全。</p>
          </div>
          <div class="culture-card">
            <div class="culture-icon">
              <i class="el-icon-view"></i>
            </div>
            <h3 class="culture-title">企业愿景</h3>
            <p class="culture-desc">成为西北地区最具影响力的工业安全检测服务提供商，引领行业发展标准。</p>
          </div>
          <div class="culture-card">
            <div class="culture-icon">
              <i class="el-icon-star-on"></i>
            </div>
            <h3 class="culture-title">核心价值观</h3>
            <p class="culture-desc">诚信为本、专业至上、创新发展、客户第一，用匠心精神铸就品质服务。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 组织架构 -->
    <section id="team" class="team-section">
      <div class="container">
        <h2 class="section-title">组织架构</h2>
        <p class="section-subtitle">科学的组织架构，高效的团队协作</p>
        
        <!-- 组织架构图 -->
        <div class="org-chart">
          <!-- 第一层：公司名称 -->
          <div class="org-level org-level-1">
            <div class="org-box org-ceo">
              <div class="org-icon">
                <i class="el-icon-office-building"></i>
              </div>
              <div class="org-title">陕西慧安和信检测有限公司</div>
            </div>
          </div>
          
          <!-- 连接线 -->
          <div class="org-connector org-connector-vertical"></div>
          
          <!-- 第二层：各部门 -->
          <div class="org-level org-level-2">
            <div class="org-departments">
              <!-- 技术检测部 -->
              <div class="org-department">
                <div class="org-box org-dept">
                  <div class="org-icon">
                    <i class="el-icon-cpu"></i>
                  </div>
                  <div class="org-title">技术检测部</div>
                  <div class="org-subtitle">检测实施与技术支持</div>
                </div>
              </div>
              
              <!-- 质量管理部 -->
              <div class="org-department">
                <div class="org-box org-dept">
                  <div class="org-icon">
                    <i class="el-icon-finished"></i>
                  </div>
                  <div class="org-title">质量管理部</div>
                  <div class="org-subtitle">质量控制与体系管理</div>
                </div>
              </div>
              
              <!-- 市场业务部 -->
              <div class="org-department">
                <div class="org-box org-dept">
                  <div class="org-icon">
                    <i class="el-icon-pie-chart"></i>
                  </div>
                  <div class="org-title">市场业务部</div>
                  <div class="org-subtitle">市场开拓与客户服务</div>
                </div>
              </div>
              
              <!-- 综合管理部 -->
              <div class="org-department">
                <div class="org-box org-dept">
                  <div class="org-icon">
                    <i class="el-icon-office-building"></i>
                  </div>
                  <div class="org-title">综合管理部</div>
                  <div class="org-subtitle">行政后勤与财务管理</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 资质荣誉 -->
    <section id="honors" class="honors-section">
      <div class="container">
        <h2 class="section-title">资质荣誉</h2>
        <div class="certificates-grid">
          <div class="certificate-item">
            <div class="certificate-image">
              <img src="@/assets/certificates/zz2.png" alt="营业执照" />
            </div>
            <h3 class="certificate-title">营业执照</h3>
          </div>
          <div class="certificate-item">
            <div class="certificate-image">
              <img src="@/assets/certificates/zz1.png" alt="资质认定证书" />
            </div>
            <h3 class="certificate-title">资质认定证书</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部区域 - 使用公共组件 -->
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'About',
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      heroBackground: require('@/assets/aboutbg.jpg')
    }
  },
  methods: {
    scrollToHash() {
      const hash = this.$route.hash
      if (hash) {
        const targetId = hash.substring(1) // 去掉 # 号
        const element = document.getElementById(targetId)
        if (element) {
          const navbarHeight = 80 // 导航栏高度
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
          const offsetPosition = elementPosition - navbarHeight
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          })
        }
      }
    }
  },
  mounted() {
    document.title = '关于我们 - 慧安检测'
    // 处理初始加载时的锚点
    this.scrollToHash()
  },
  watch: {
    '$route'(to) {
      // 监听路由变化，处理锚点滚动
      if (to.hash) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToHash()
          }, 100)
        })
      }
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  background: #ffffff;
}

/* Hero Section */
.hero-section {
  height: 470px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.1) 100%);
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.hero-content {
  text-align: center;
  color: white;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 16px 0;
  animation: fadeInUp 0.8s ease-out;
}

.hero-subtitle {
  font-size: 24px;
  margin: 0 0 16px 0;
  opacity: 0.95;
  animation: fadeInUp 0.8s ease-out 0.1s both;
}

.hero-description {
  font-size: 16px;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
  opacity: 0.9;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 通用样式 */
.section-title {
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  margin: 0 0 32px 0;
  color: #333333;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -12px;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 2px;
}

.section-subtitle {
  text-align: center;
  font-size: 18px;
  color: #666666;
  margin: 16px 0 32px 0;
  line-height: 1.6;
}

/* 公司简介 */
.company-intro-section {
  padding: 50px 0;
  background: #ffffff;
}

.intro-wrapper {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 40px;
  align-items: center;
}

.intro-text {
  margin-bottom: 40px;
}

.intro-text p {
  font-size: 16px;
  line-height: 1.8;
  color: #666666;
  margin: 0 0 20px 0;
  text-align: justify;
}

.company-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.stat-item {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s;
}

.stat-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  color: #1e3a8a;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #666666;
}

.intro-image {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.intro-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-badge {
  position: absolute;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* 企业文化 */
.culture-section {
  padding: 50px 0;
  background: #f7f8fa;
}

.culture-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.culture-card {
  background: white;
  padding: 40px 32px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
}

.culture-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
}

.culture-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.culture-icon i {
  font-size: 32px;
  color: white;
}

.culture-title {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 16px 0;
}

.culture-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #666666;
  margin: 0;
}

/* 组织架构 */
.team-section {
  padding: 50px 0;
  background: #f7f8fa;
}

.org-chart {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px 20px;
}

/* 组织架构层级 */
.org-level {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

/* 连接线 */
.org-connector {
  margin: 0 auto;
}

.org-connector-vertical {
  width: 2px;
  height: 40px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  margin-bottom: 24px;
}

/* 组织盒子 */
.org-box {
  background: white;
  border-radius: 12px;
  padding: 24px 32px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-align: center;
  position: relative;
}

.org-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
}

/* 公司名称样式 */
.org-ceo {
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  color: white;
  min-width: 320px;
  max-width: 420px;
}

.org-ceo .org-icon {
  background: rgba(255, 255, 255, 0.2);
}

.org-ceo .org-icon i {
  color: white;
}

.org-ceo .org-title {
  color: white;
  font-size: 20px;
  font-weight: 700;
}

/* 部门样式 */
.org-dept {
  min-width: 220px;
  border: 2px solid #e8e8e8;
}

.org-dept:hover {
  border-color: #1e3a8a;
}

/* 图标 */
.org-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.org-icon i {
  font-size: 28px;
  color: white;
}

/* 标题 */
.org-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.org-subtitle {
  font-size: 13px;
  color: #666666;
  line-height: 1.5;
}

/* 部门网格 */
.org-departments {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  width: 100%;
  position: relative;
}

.org-departments::before {
  content: '';
  position: absolute;
  top: -24px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
}

/* 部门容器 */
.org-department {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.org-department::before {
  content: '';
  position: absolute;
  top: -24px;
  left: 50%;
  width: 2px;
  height: 24px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  transform: translateX(-50%);
}

/* 子项目 */
.org-sub-items {
  margin-top: 16px;
  width: 100%;
}

.org-sub-item {
  background: #f5f7fa;
  padding: 8px 12px;
  margin: 6px 0;
  border-radius: 6px;
  font-size: 12px;
  color: #666666;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.org-sub-item:hover {
  background: #e8ecf1;
  border-color: #1e3a8a;
  color: #1e3a8a;
}

/* 资质荣誉 */
.honors-section {
  padding: 50px 0;
  background: #ffffff;
}

.certificates-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  max-width: 1000px;
  margin: 0 auto;
}

.certificate-item {
  text-align: center;
}

.certificate-image {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}

.certificate-image:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.2);
}

.certificate-image img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.certificate-image:hover img {
  transform: scale(1.05);
}

.certificate-title {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  margin: 24px 0 0 0;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .hero-section {
    height: 470px;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 20px;
  }

  .intro-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .culture-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  /* 组织架构响应式 */
  .org-departments {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .org-sub-item {
    font-size: 11px;
    padding: 6px 10px;
  }
  
  .org-dept {
    min-width: 180px;
  }

  .certificates-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  .company-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 300px;
    padding: 80px 0 40px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 18px;
  }

  .section-title {
    font-size: 28px;
  }

  .culture-grid,
  .certificates-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  
  .certificate-title {
    font-size: 18px;
  }

  /* 组织架构移动端样式 */
  .org-departments {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .org-chart {
    padding: 20px 10px;
  }
  
  .org-ceo {
    min-width: auto;
    max-width: 100%;
    padding: 20px 16px;
  }
  
  .org-ceo .org-title {
    font-size: 16px;
  }
  
  .org-dept {
    min-width: auto;
    width: 100%;
  }
  
  .org-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 12px;
  }
  
  .org-icon i {
    font-size: 24px;
  }
  
  .org-title {
    font-size: 16px;
  }
  
  .org-subtitle {
    font-size: 12px;
  }
  
  .org-sub-item {
    font-size: 11px;
    padding: 6px 8px;
  }

  .company-stats {
    grid-template-columns: 1fr;
  }
}
</style>
